import { announcementNotification } from '../../statusBar/components';
import showNotificationCentered from '../../utils/showNotificationCentered';
import Statusbar from '../../Statusbar';
import { compareAnnouncements } from '../../statusBar/announcementsService';

const notificationDuration = 10;

export default function announcementExecutor(announcement, done) {
	const {
		uuid,
		type,
		author,
		title,
		isShown,
	} = announcement;
	if (isShown) {
		log(`Notifications.doAnnouncement show "${uuid}" stating "${title}" with type ${type} and author ${author}`);
		const currentlyShown = Statusbar.getCurrentlyShownAnnouncement(uuid);
		if (!currentlyShown || !compareAnnouncements(announcement, currentlyShown)) {
			
			if (currentlyShown) {
				Statusbar.cancelAnnouncement(uuid);
			}

			Statusbar.addAnnouncement(announcement);
			const notification = announcementNotification(announcement);
			return showNotificationCentered($(notification), notificationDuration, done);
		} else {
			done();
		}
	} else {
		log(`Notifications.doAnnouncement hide "${uuid}"`);
		Statusbar.cancelAnnouncement(uuid);
		done();
		return () => {};
	}
}

